export let januaryUppercase = "u_KUzd";
export default {januaryUppercase};